import { TagSchema } from '../hooks/use-tag-schema';

export const iconStyle = (schema: TagSchema) => {
	return {
		_active: {
			bg: schema.activeIcon,
			color: 'white',
		},
	};
};
